import React from "react";


const SumInfo = ({ pricedOrder }) => {
    console.log('SumInfo render', pricedOrder);
	let T = window.Texts.checkout;
	return (
		<div className="pcol recapitulation span-4">
			<div className="box">
				<h3>{T.summary}</h3>
				<div className="xo-products">
					{pricedOrder.cartedProducts.map((item) => {
						return (<div className="xo-product" key={'product' + item.product.id}>
							<img className="xo-thumb" src={(item.product.thumb) ? item.product.thumb.url : ''} />
							<div className="xo-name">{(item.count > 1) ? item.count + 'x' : ''}{item.product.name}</div>
							<div className="xo-price">{item.priceTable.displayTotalPriceInclVat} </div>
							<div style={{ clear: 'both' }} />
						</div>);
					})}
					<table>
						<tbody><tr>
							<td className="name">{T.yourCart}</td>
							<td className="value">{pricedOrder.partialPriceTable.cart.displayTotalPriceInclVat}</td>
						</tr>
							{(pricedOrder.partialPriceTable.couponDiscount.totalPriceInclVat > 0) ?
								<tr>
									<td className="name" style={{ color: 'green' }}>{T.couponDiscount} {pricedOrder.coupon?.code}</td>
                                    <td className="value" style={{ color: 'green' }}>-{pricedOrder.partialPriceTable.couponDiscount.displayTotalPriceInclVat}</td>
								</tr> : null}
							<tr>
								<td className="name">{T.shipping}</td>
								{(window.Config.mode == 'liveua') ?
									<td className="value">{pricedOrder.partialPriceTable.shipping.totalPriceInclVat ? pricedOrder.partialPriceTable.shipping.displayTotalPriceInclVat : T.tarif}</td> :
									<td className="value">{pricedOrder.partialPriceTable.shipping.totalPriceInclVat ? pricedOrder.partialPriceTable.shipping.displayTotalPriceInclVat : T.free}</td>}
							</tr>
							{(pricedOrder.partialPriceTable.payment.totalPriceInclVat > 0) ?
								<tr>
									<td className="name">{T.cashOnDelivery}</td>
									<td className="value">{pricedOrder.partialPriceTable.payment.displayTotalPriceInclVat}</td>
								</tr> : null}
							<tr>
								<td className="name" style={{ lineHeight: 'normal' }}><strong>{T.total}</strong><br />
								</td>
								<td className="value">
									<strong>{pricedOrder.priceTable.displayTotalPriceInclVat}</strong>
									{T.withoutVat ? <p style={{ fontSize: 'small', whiteSpace: 'nowrap' }}>{pricedOrder.priceTable.displayTotalPriceExclVat.concat(' ', T.withoutVat)}</p> : null}
								</td>
							</tr>

						</tbody>
					</table>
				</div>


				<div className="xo-discount">
					<table>
						<tbody><tr>
							<td className="name"><strong>{T.totalForProducts}:</strong></td>
							<td className="value"><strong>{pricedOrder.partialPriceTable.cart.displayBasePriceInclVat}</strong></td>
						</tr>
							<tr>
								<td className="name discount-name">
									<strong>{T.totalDiscount}:</strong>
								</td>
								<td className="value discount-value">
									<strong>{pricedOrder.priceTable.displayDiscountInclVat}</strong>
								</td>
							</tr>
							<tr>
								<td className="name  discount-percent">{T.discount}:</td>
								<td className="value discount-percent">{pricedOrder.priceTable.displayDiscountPerCent}</td>
							</tr>

						</tbody>
					</table>
				</div>
			</div>
		</div>);
}
export default SumInfo;